import { render, staticRenderFns } from "./ListChargebackType.vue?vue&type=template&id=72eb2a07&"
import script from "./ListChargebackType.vue?vue&type=script&lang=js&"
export * from "./ListChargebackType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports